module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "styleEditor"
  }, [_c('div', {
    staticClass: "code",
    domProps: {
      "innerHTML": _vm._s(_vm.styleTag)
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedCode)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3696a0fe","hasScoped":true}!./~/._vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/StyleEditor.vue
// module id = 94
// module chunks = 1